import { Brand } from 'AppBranding';
import { useTargetBrandConfig } from 'FrontRoyalAngular';
import { useTranslation } from 'react-i18next';
import { CornerIcon } from 'CornerIcon';
import './locales/nextUp/nextUp-en.json';

export const NextUpIcon = () => {
    const brand = useTargetBrandConfig();
    const { t } = useTranslation('back_royal', { keyPrefix: 'nextUp.nextUp' });

    return <CornerIcon color={brand.branding === Brand.quantic ? 'coral' : 'blue'} text={t('nextUp')} />;
};
